import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CepCreationMode } from 'basics/enums/cep.enums';
import CepTemplateSelectorFilters from 'components/CepTemplateSelectorFilters/CepTemplateSelectorFilters';
import useCepTemplateSelectorForm from 'components/CepTemplateSelectorForm/CepTemplateSelectorForm.hook';
import {
  cepTemplateCreationModeStyle,
  filtersTitleStyle,
} from 'components/CepTemplateSelectorForm/CepTemplateSelectorForm.styles';
import CepTemplateSelectorList from 'components/CepTemplateSelectorList/CepTemplateSelectorList';
import FormContainer from 'components/FormContainer/FormContainer';
import { FormLayoutContainer } from 'components/FormLayout';
import Box from 'yoda-ui/components/Box';
import RadioGroup from 'yoda-ui/components/Form/RadioGroup/RadioGroup';
import { YodaJustifyContent } from 'yoda-ui/yodaTheme';

const CepTemplateSelectorForm: FC = () => {
  const {
    cepCreationMode,
    cepTemplateSelectorFormConfig,
    providerFields,
    setCepTemplateSelectorFilters,
    setCepSortFilter,
    submitButtonConfig,
    ceps,
    loading,
    count,
    onPageChange,
    onPageSizeChange,
  } = useCepTemplateSelectorForm();
  const { t } = useTranslation();

  return (
    <>
      <FormContainer
        providerFields={ providerFields }
        { ...(cepCreationMode === CepCreationMode.custom ? { submitButtonConfig } : {}) }
      >
        <FormLayoutContainer justifyContent={ YodaJustifyContent.center } flexDirection='column' >
          <Box sx={ filtersTitleStyle } >
            { t('maya_choose_cep_template_title') }
          </Box>
          <RadioGroup { ...cepTemplateSelectorFormConfig.selectCreationMode } sx={ cepTemplateCreationModeStyle } />
        </FormLayoutContainer>
      </FormContainer>

      {
        cepCreationMode === CepCreationMode.template && (
          <>
            <CepTemplateSelectorFilters
              setCepTemplateSelectorFilters={ setCepTemplateSelectorFilters }
              setCepSortFilter={ setCepSortFilter }
              ceps={ ceps }
              count={ count }
              loading={ loading }
            />
            <CepTemplateSelectorList
              ceps={ ceps }
              loading={ loading }
              count={ count }
              onPageChange={ onPageChange }
              onPageSizeChange={ onPageSizeChange }
            />
          </>
        )
      }
    </>
  );
};

export default CepTemplateSelectorForm;
